export const getUserRole = () => {
  const data = localStorage.getItem("user_role");
  return data ? JSON.parse(data) : [];
};
export const getUser = () => {
  const data = localStorage.getItem("user");
  return data ? JSON.parse(data) : [];
};

export const isAdmin = () => {
  const userRole = getUserRole();
  return userRole?.id === 1 || userRole?.id === 2;
};

export const isHR = () => {
  const userRole = getUserRole();
  return userRole?.id === 3;
};

export const isTL = () => {
  const userRole = getUserRole();
  return userRole?.id === 4;
};

export const isManager = () => {
  const userRole = getUserRole();
  return userRole?.id === 7;
};

export const getPermissions = () => {
  const data = localStorage.getItem("permissions");
  return data ? JSON.parse(data) : [];
};

export const hasPermission = (key) => {
  const userPermissions = getPermissions();
  return userPermissions.includes(key);
};
